export const OPEN_SHIFT_REQUEST_TYPES = ["open-shift", "call-off", "direct-offer"];
